import { axiosInstance } from '@configs/axios/axiosInstance';

import { User } from '../types/user.types';
import { CreateUserRequest } from './createUser.types';

/**
 * Create a new B2C user for a given organization.
 * Endpoint: POST /users
 *
 * `organizationId` is sent as the X-Organization-ID request header.
 * Returns the created user with server-generated fields.
 */
export async function createUser(
  organizationId: string,
  data: CreateUserRequest
): Promise<User> {
  const response = await axiosInstance.post<User>('/users', data, {
    headers: { 'X-Organization-ID': organizationId },
  });

  return response.data;
}
